export default "__VITE_ASSET__B$s1n2nt__"